// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"d51c5129","736":"38ff2584"}[chunkId] + ".chunk.js";
};